import { Component, OnInit } from '@angular/core';
import { AccountpopupComponent } from 'src/app/v2/components/accountpopup/accountpopup.component';
import { ModalController } from '@ionic/angular';
import { LoginService } from '../login/login.service';
import { TranslatorService } from 'src/app/translator.service';

@Component({
  selector: 'app-signup',
  templateUrl: './signup.page.html',
  styleUrls: ['./signup.page.scss'],
})


export class SignupPage implements OnInit {

  constructor(private modalCtrl:ModalController, private loginService:LoginService, public translator:TranslatorService) { }


  async ngOnInit() {

  }


  ionViewWillEnter() {
    this.openDropDownModal();
  }

  public openDropDownModal() {
    this.modalCtrl.create({
      component: AccountpopupComponent,
      componentProps:
      {
          loginService:this.loginService, 
      },
      cssClass: "modal-fullscreen",
      id: "accountpopup"
    }).then(modalEl => {
      modalEl.present();
      return modalEl.onDidDismiss();
    }).then(resultData => {
      if (resultData.role === "confirm") {

      }

    })
  }
}
